export class DinneyUtil {

    static setOrder(a : any, b : any, aId : any, bId : any, descending : boolean) : number {
        if (a < b) {
            return descending ? -1 : 1
        }
        if (a > b) {
            return descending ? 1 : -1
        } else if (aId !== undefined && bId !== undefined) {
            if (aId < bId) {
                return descending ? -1 : 1
            }
            if (aId > bId) {
                return descending ? 1 : -1
            }
        }
        return 0;
    }
}